import { useCallback } from 'react';
import { Controller } from 'react-hook-form';
import { Icons } from 'shared';

import { debouncedRefCodeValidator } from '../../lib';
import { ReferralInput } from '../styled';

export const Tap2MineReferralInput = () => {
  const validateRefCode = useCallback(async (value: string) => {
    if (!value) return true;

    return new Promise<boolean | string>((resolve) => {
      debouncedRefCodeValidator(value, resolve);
    });
  }, []);

  return (
    <Controller
      name="refCode"
      rules={{
        validate: validateRefCode,
      }}
      render={({ field, fieldState: { invalid, isValidating }, formState: { isValid } }) => {
        const isValidCode = isValid && field.value && !isValidating;
        const isInvalidCode = (invalid || !isValid) && !isValidating;

        return (
          <ReferralInput
            id="refCode"
            {...field}
            placeholder="Invitation Code"
            spellCheck={false}
            // Disable revalidation on blur by overriding onBlur with a no-op
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onBlur={() => {}}
            $success={isValidCode}
            $error={isInvalidCode}
            InputProps={{
              endAdornment:
                (isValidCode && <Icons.Check width={18} height={18} />) ||
                (isInvalidCode && <Icons.Close color="error" width={12} height={12} />),
            }}
            sx={{
              mb: 2,
              pr: 2,
              height: 40,
            }}
          />
        );
      }}
    />
  );
};
